export default "__VITE_ASSET__b60f1b0c__"